// Packages
import { Routes, Route }  from 'react-router-dom';
import { useSelector } from 'react-redux';

// Importing Views
import CapitalProjectsDashboard from 'views/CapitalProjectsDashboard';
import ProjectKPIsDashboard from 'views/ProjectKPIsDashboard';
import TroubledProjectsDashboard from 'views/TroubledProjectsDashboard';
import DelayedProjectsDashboard from 'views/DelayedProjectsDashboard';
import ProjectsPerformanceDashboard from 'views/ProjectsPerformanceDashboard';
import TimeOverrunProjects from 'views/TimeOverrunProjects';
import ChangeOrderDashboard from 'views/ChangeOrderDashboard';
import ContractorAnalysis from 'views/ContractorAnalysis';
import WithdrawnProjectsDashboard from 'views/WithdrawnProjectsDashboard';
import SuspendedProjectsDashboard from 'views/SuspendedProjectsDashboard';


// Importing Components
import Header from './components/Header';
import Navigation from './components/Navigation';

// Scss
import './App.css';
import './assets/scss/master.scss';



function App() {
  const selectedTheme = useSelector((state)=>state.globalConfig.theme)

  if( selectedTheme === 'dark'){
      document.getElementsByTagName("body")[0].classList.add("dark");
      document.getElementsByTagName("body")[0].classList.remove("light");
  }

  if(selectedTheme === 'light'){
    document.getElementsByTagName("body")[0].classList.add("light");
    document.getElementsByTagName("body")[0].classList.remove("dark");
  }
  return (
    <>
    <Header/>
    <div className='main-container'>
        <Navigation/>
        <div className='content-wrapper'>
          <Routes>
            <Route path="/" element={<CapitalProjectsDashboard/>} />
            <Route path="/capital-projects-dashboard" element={<CapitalProjectsDashboard/>} />
            <Route path="/project-kpis" element={<ProjectKPIsDashboard/>} />
            <Route path="/troubled-projects-dashboard" element={<TroubledProjectsDashboard/>} />
            <Route path="/delayed-projects-dashboard" element={<DelayedProjectsDashboard/>} />
            <Route path="/projects-performance-dashboard" element={<ProjectsPerformanceDashboard/>} />
            <Route path="/time-overrun-projects" element={<TimeOverrunProjects/>} />
            <Route path="/change-order" element={<ChangeOrderDashboard/>} />
            <Route path="/contractor-analysis" element={<ContractorAnalysis/>}></Route>
            <Route path="/withdrawn-projects-dashboard" element={<WithdrawnProjectsDashboard/>}></Route>
            <Route path="/suspended-projects-dashboard" element={<SuspendedProjectsDashboard/>}></Route>
          </Routes>
        </div>
    </div>
    </>
  );
}

export default App;
